import { DefaultFulfillmentSettingsResult , EstimateFulfillmentWeightAndCostResult} from '../../common/ui/generated';

export interface GetDefaultFulfillmentSettingsQuery {
    defaultFulfillmentSettings: DefaultFulfillmentSettingsResult | null;
}

export interface GetDefaultFulfillmentSettingsQueryVariables {
    orderId: string;
}

export interface GetEstimateFulfillmentWeightAndCostQuery {
    estimateFulfillmentWeightAndCost: EstimateFulfillmentWeightAndCostResult | null;
}

export interface GetEstimateFulfillmentWeightAndCostQueryVariables {
    orderId: string;
    parcelProfileId: string;
    shippingServiceType: string;
    customWeight: number | null;
}

export enum ShippingServiceType {
    STANDARD = 'standard',
    EXPRESS = 'express',
    NEXT_DAY = 'next-day'
}

export interface FulfillmentArgs {
    parcelProfileId: string | null;
    totalWeight: number | null;
    shippingServiceType: ShippingServiceType;
    rateId: string | null;
}